export default "__VITE_ASSET__BGGRx9yq__"